/* eslint-disable */
import { useContext } from 'react';
import ButtonComponent from '../../../../Components/Button/button';
import PropTypes from 'prop-types';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { ReactComponent as  ArrowDropDownIcon} from '../../../../Assets/images/svg/white_down_arrow.svg';
import '../../NewRequest/techSession.scss';
import { AuthContext } from '../../../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../../../Constants/modules';
import Tooltip from '@mui/material/Tooltip';

const ActionButtons = ({
  selectedRows,
  onGenericEmail,
  onCustomizeEmail,
  anchorEl,
  handleButtonClick,
  handleClose,
  disabled,
}) => {
  const { userProfile } = useContext(AuthContext);

  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.TECH_SESSION_NEW_REQUEST] || []
    : [];
  const isButtonDisabled = disabled;
  const hasAccess = (action) => {
    return permission.includes(action);
  };

  return (
    <div className="tech-session-users-button">
      <Tooltip
        title={disabled ? 'Select users to send email' : ''}
        placement="bottom"
        arrow={false}
        disableHoverListener={!disabled}
        classes={{ tooltip: 'send-email-btn-tooltip' }}
      >
        <span style={{ display: 'inline-block' }}>
          <ButtonComponent
            disabled={disabled || !hasAccess('create')}
            className="send-users-btn"
            id="send-users-btn"
            label={
              <span className="send-email-label">
                Send email <ArrowDropDownIcon 
                style={{
                  marginLeft: 4,
                  pointerEvents: 'none',
                  filter: disabled ? 'grayscale(100%)' : 'none',
                }} />
              </span>
            }

            variant="contained"
            onClick={handleButtonClick}
            btnCss={
              disabled
                ? 'send-users-btn send-users-btn-disabled'
                : 'send-users-btn violet-btn'
            }
          />
        </span>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        MenuListProps={{
          className: 'custom-menu-list'
        }}
        PaperProps={{
          className: 'custom-menu-paper'
        }}
      >
        <MenuItem
          onClick={onGenericEmail}
          className="tech-session-user-actions-dropdown"
        >
          Generic email
        </MenuItem>
        <MenuItem
          onClick={onCustomizeEmail}
          className="tech-session-user-actions-dropdown"
        >
          Customized email
        </MenuItem>
      </Menu>
    </div>
  );
};

ActionButtons.propTypes = {
  selectedRows: PropTypes.array.isRequired,
  onGenericEmail: PropTypes.func.isRequired,
  onCustomizeEmail: PropTypes.func.isRequired,
  anchorEl: PropTypes.object,
  handleButtonClick: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default ActionButtons;